/// <amd-module name="typeahead/core/plugins/ExecutionHelper" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../../typings/typeahead/browser.d.ts" />
/// <reference path="../../../typings/typeahead/modulizr.d.ts" />
/// <reference path="../../../typings/typeahead/plugins.d.ts" />

import {ABTest} from "typeahead/core/ABTest";
import {Experiment} from "typeahead/core/Experiment";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

// prop mapping between StripingConfigration's properties and Context's properties

const supportedProperties = {
    clients : "clientId",
    deviceTypes : "deviceType",
    lobs : "lob",
    locales: "locale",
    packageTypes: "getShortPackageType",
    siteids : "siteid",
    tabs : "tab",
};

export const abTest = new ABTest();

export function evaluateExperiment(experiment: Experiment, abTestInstance = abTest): boolean {
    const evaluatedExp: Experiment = abTestInstance.getAndLog(experiment);
    return experiment.value !== undefined ? experiment.value === evaluatedExp.value : evaluatedExp.value > 0;
}

function getContextProp(configProp: string): string {
    return supportedProperties.hasOwnProperty(configProp) ? supportedProperties[configProp] : null;
}

function getApplicableConfiguration(
                    context: IContext, stripingConfigurations: IStripingConfiguration[]): IStripingConfiguration {
    let stripingConfiguration: IStripingConfiguration;
    for (let i: number = 0; i < stripingConfigurations.length; i++) {
        stripingConfiguration = stripingConfigurations[i];
        let isConfigApplicable: boolean = true;

        for (const configProp in stripingConfiguration) {
            if (configProp === "experiment") {
                continue;
            } else if (stripingConfiguration.hasOwnProperty(configProp) && stripingConfiguration[configProp]) {
                if (configProp === "restricted") {
                    for (const restrictedConfigProp in stripingConfiguration[configProp]) {
                        if (stripingConfiguration[configProp][restrictedConfigProp]) {
                            const contextProp: string = getContextProp(restrictedConfigProp);
                            const contextPropVal: string = typeof context[restrictedConfigProp] === "function" ?
                                context[contextProp]() : context[contextProp];
                            if (contextProp &&
                                stripingConfiguration[configProp][restrictedConfigProp].indexOf(contextPropVal) > -1) {
                                isConfigApplicable = false;
                                break;
                            }
                        }
                    }
                } else {
                    const contextProp: string = getContextProp(configProp);
                    const contextPropVal: string = typeof context[contextProp] === "function" ? context[contextProp]() :
                        context[contextProp];
                    if (contextProp && stripingConfiguration[configProp].indexOf(contextPropVal) < 0) {
                        isConfigApplicable = false;
                        break;
                    }
                }
            }
        }
        if (isConfigApplicable) {
            return stripingConfiguration;
        }
    }
    return undefined;
}

// the abTestInstance optional argument is for unit testing
export function shouldExecute(context: IContext, stripingConfigurations: IStripingConfiguration[],
                              abTestInstance = abTest): boolean {
    if (!stripingConfigurations || !stripingConfigurations.length ||  !context) {
        return true;
    }
    const stripingConfig: IStripingConfiguration = getApplicableConfiguration(context, stripingConfigurations);

    if (stripingConfig) {
        const experiment = stripingConfig.experiment;
        if (experiment) {
            return evaluateExperiment(experiment, abTestInstance);
        } else {
            return true;
        }
    } else {
        return false;
    }
}

/**
 * NOTE: Please do not use this function
 * @returns {Experiment}
 */
export function doNotCallThisToGetEvaluatedExperimentInfo(context: IContext,
                                                          stripingConfigurations: IStripingConfiguration[],
                                                          abTestInstance = abTest): Experiment | undefined {
    let experiment: Experiment;
    if (context) {
        const stripingConfig: IStripingConfiguration = getApplicableConfiguration(context, stripingConfigurations);
        if (stripingConfig) {
            experiment = abTestInstance.getAndLog(stripingConfig.experiment);
        }
    }
    return experiment;
}
